module.exports = __webpack_public_path__ + "img/vercion.9d35d169.png";